"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
var _activationCode = require("@/api/activationCode");
var _qrcode = _interopRequireDefault(require("qrcode.vue"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment'
var _default = exports.default = {
  name: "LoopCode",
  components: {
    QrcodeVue: _qrcode.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    internalTitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      codeImg: null,
      dialogVisible: false,
      codeDialogVisible: false,
      limitDialogVisible: false,
      loading: false,
      codeList: [],
      originalCodeList: [],
      errorMsg: "",
      errorStyle: "",
      disableGenButton: false,
      form: {
        loop: "",
        numberOfCodes: 0,
        userLimit: 0
      }
    };
  },
  created: function created() {
    if (this.parentId !== "copy") {
      this.form.loop = this.parentId;
      this.getCode();
    }
  },
  methods: {
    openDialogBox: function openDialogBox() {
      // this.$refs.qrcode.open()
      this.dialogVisible = true;
      this.errorMsg = "";
      this.form.userLimit = 1;
      this.form.numberOfCodes = 1;
      this.disableGenButton = false;
    },
    genCode: function genCode() {
      var _this = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var oEmail = (0, _cookie.getCookie)("EMAIL");

      // console.log('gencode-form', this.form)

      (0, _activationCode.generateCode)(token, this.form).then(function (response) {
        _this.codeList = _this.codeList.concat(response.data);
        (0, _ga.writeGaEvent)(_this, "Loop", "".concat(_lifehikesInitData.userEvent.loop.generateCode), oEmail, "Loop Id: ".concat(_this.form.loop));
        _this.errorMsg = "Error : Fail to generate the code";
        _this.errorStyle = "color:#67C23A";
        _this.disableGenButton = true;
        _this.getCode();
        _this.dialogVisible = false;
        var msg = "QR code is generated successfully";
        (0, _log.displayPopupMessage)(msg, "success");
      }).catch(function (error) {
        (0, _log.showDebugLog)("GenerateCode-API-error", error);
        _this.errorMsg = "Error : Fail to generate the code";
        _this.errorStyle = "color:#F56C6C";
        (0, _log.displayPopupMessage)(_this.errorMsg, "error");
      });
    },
    getCode: function getCode() {
      var _this2 = this;
      var id = this.form.loop;
      // console.log('hikeID', id)
      if (!id) return;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var query = {
        page: 1,
        limit: 100,
        sort: "status",
        loop: id
      };
      this.loading = true;
      (0, _activationCode.getCodeList)(token, query).then(function (response) {
        _this2.loading = false;
        (0, _log.showDebugLog)("loop-Code-Search-response", response);
        _this2.codeList = _lodash.default.cloneDeep(response.data.rows);
        _this2.originalCodeList = _lodash.default.cloneDeep(response.data.rows);
      }).catch(function (error) {
        (0, _log.showDebugLog)("loop-code-search-api-error", error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    updateLimit: function updateLimit(c, index) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      var oEmail = (0, _cookie.getCookie)("EMAIL");
      var body = {
        userLimit: c.userLimit
      };
      if (this.originalCodeList[index].userLimit >= c.userLimit) {
        (0, _log.displayPopupMessage)("Reuse value cannot be smaller than before", "error");
        return;
      }
      (0, _activationCode.updateCode)(token, c.id, body).then(function (response) {
        (0, _ga.writeGaEvent)(_this3, "Loop", "".concat(_lifehikesInitData.userEvent.loop.updateCode), oEmail, "Loop Id: ".concat(c.loop));
        _this3.getCode();
        (0, _log.displayPopupMessage)("QR Code is updated", "success");
      }).catch(function (error) {
        (0, _log.showDebugLog)("loop-code-updatelimit-api-error", error);
        (0, _log.displayPopupMessage)("Fail to update QR code", "error");
      });
    },
    showQRCodePath: function showQRCodePath(code) {
      return _lifehikesInitData.qrPrefix + code;
    },
    printCode: function printCode(idx) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var el, options;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              el = _this4.$refs.displayCode;
              _this4.codeDialogVisible = true;

              // console.log('element', el)
              options = {
                type: "dataURL"
              };
              _context.n = 1;
              return _this4.$html2canvas(el[idx], options);
            case 1:
              _this4.codeImg = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};